import VirtualDataTable from './VirtualDataTable'
import VirtualDataTableColumn from './VirtualDataTableColumn'

export default function install(Vue) {
  Vue.component('VirtualDataTable', VirtualDataTable)
  Vue.component('VirtualDataTableColumn', VirtualDataTableColumn)
}
